import axios from 'axios';

// Separate client for auth.inputoutputlabs.com
const authApi = axios.create({
  baseURL: import.meta.env.VITE_AUTH_BASE_URL || 'https://auth.inputoutputlabs.com/api/v2',
  headers: { 'Content-Type': 'application/json' },
});

export default authApi;
